<template>
  <div
    class="tabslider o-body grid grid-cols-2 relative"
    role="tablist"
    aria-label="Content type selector"
  >
    <div
      class="tabslider-slider duration-500 lg:duration-800"
      :class="[mode == modes.loyalty ? 'tabslider-slider-active' : '']"
      aria-hidden="true"
    />
    <div
      class="flex items-center justify-center cursor-pointer relative py-3 focus:ring-2 focus:ring-primary focus:ring-offset-2"
      :class="[mode == modes.gifts ? 'tabslider-active' : '']"
      role="tab"
      tabindex="0"
      :aria-selected="mode === modes.gifts"
      @click="setMode(modes.gifts)"
      @keydown.right.prevent="setMode(modes.loyalty)"
      @keydown.left.prevent="setMode(modes.gifts)"
      @keydown.enter.prevent="setMode(modes.gifts)"
    >
      <div>
        <OSvg
          class="fill-current"
          :svg="mode == modes.gifts ? 'new-gift-solid' : 'new-gift-outline'"
          aria-hidden="true"
        />
      </div>
      <p class="px-1" v-text="buttonOneText || $t('Account.Home.TabSlider.Gifts')" />
      <div v-if="notifications" aria-label="notifications">
        <div class="notification o-footer font-bold bg-neutral-800 text-neutral-50" v-text="notifications" />
      </div>
    </div>
    <div
      class="flex items-center justify-center cursor-pointer relative py-3 transition-colors ring-offset-2 ring-2 ring-transparent focus:ring-primary"
      :class="[mode == modes.loyalty ? 'tabslider-active' : '']"
      role="tab"
      :aria-selected="mode === modes.loyalty"
      tabindex="0"
      @click="setMode(modes.loyalty)"
      @keydown.right.prevent="setMode(modes.loyalty)"
      @keydown.left.prevent="setMode(modes.gifts)"
      @keydown.enter.prevent="setMode(modes.loyalty)"
    >
      <div>
        <OSvg
          class="fill-current"
          :svg="mode == modes.loyalty ? 'new-star-solid' : 'new-star-outline'"
          aria-hidden="true"
        />
      </div>
      <p class="px-1" v-text="buttonTwoText || $t('Account.Home.TabSlider.Loyalty')" />
    </div>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export const modes = {
  gifts: 'gifts',
  loyalty: 'loyalty'
}

export default {
  name: 'TabSlider',
  components: {
    OSvg
  },
  props: {
    notifications: {
      type: Number,
      default: 0
    },
    buttonOneText: {
      type: String,
      default: ''
    },
    buttonTwoText: {
      type: String,
      default: ''
    },
    startMode: {
      type: String,
      default: modes.gifts
    }
  },
  data () {
    return {
      mode: this.startMode
    }
  },
  computed: {
    activeClasses () {
      return {
        color: 'text-neutral-00',
        notificationColor: 'text-yellow-400',
        notificationbgColor: 'text-neutral-00'
      }
    },
    modes () {
      return modes
    }
  },
  methods: {
    setMode (newMode) {
      if (this.mode !== newMode) {
        this.mode = newMode
        this.$emit('switch', { mode: newMode })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.tabslider {
  @apply bg-neutral-200;
  border-radius: 10rem;

  svg {
    width: 1.4rem;
  }

  button {
    border-radius: 10rem;

    &:focus {
      outline: 2px solid #36C0B6;
      outline-offset: -2px;
      position: relative;
      z-index: 1;
    }
  }

  &-slider {
    @apply h-full bg-yellow-400 absolute transition-transform ease-in-out;
    border-radius: 10rem;
    width: 50%;

    &-active {
      transform: translate(100%, 0);
    }
  }

  &-active {
    .notification {
      @apply text-yellow-400 bg-neutral-00;
      -webkit-transition: all .3s ease-in-out;
      -moz-transition: all .3s ease-in-out;
      -o-transition: all .3s ease-in-out;
      transition: all .3s ease-in-out;
    }
  }

  .notification {
    padding: 0 .6rem;
    border-radius: .4rem;
    -webkit-transition: all .3s ease-in-out;
    -moz-transition: all .3s ease-in-out;
    -o-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
  }
}
</style>
